<div fxFlex [fxLayoutAlign]="wrapperLayoutAlign" fxLayoutGap="25px">

  <div [fxFlex]="labelFlex">
    {{ textLabel | translate }}*
  </div>

  <div [fxFlex]="formWrapperFlex">
    <form [formGroup]="formGroup"> 
      <mat-form-field class="width-100">
        <mat-chip-list #chipsGroup aria-label="Group" required>
          <mat-chip *ngFor="let data of multiSelect.selectedGroups"  [removable]="true" (removed)="toggleSelection(data, groups, 'selectedGroups', 'group')">
            {{data.description}}
            <mat-icon matChipRemove>cancel</mat-icon>
          </mat-chip>
        
          <input 
            matInput 
            required
            #groupInput 
            [matChipInputFor]="chipsGroup" 
            formControlName="group" 
            [matChipInputAddOnBlur]="true"
            [matAutocomplete]="groupAC" 
            (focus)="!loading.group && getInitialValues('group')" 
            (blur)="checkAutocompleteObject(formGroup, 'group', 'selectedGroups')"
            >
        
          <!-- <mat-icon *ngIf="groupInput.value" matSuffix svgIcon="close-circle-outline" (click)="resetControl(formGroup.get('group')); groupInput.value = ''"></mat-icon> -->
        
          <mat-icon 
            matSuffix 
            svgIcon="menu-down" 
            *ngIf="!groupInput.value" 
            class="autocomplete-arrow-color cursor-pointer"
            (click)="groupInput.focus()" 
            >
          </mat-icon>
        </mat-chip-list>
 
        <mat-autocomplete 
          id="id_group_dropdown"
          [displayWith]="displayFn"
          #groupAC="matAutocomplete" 
          (opened)="autocompleteScroll('group','groupACRef','groupACTr')"
          (closed)="autoCmpltClosed()"
          >
        <mat-option
          disabled
          *ngIf="!loading.group && groups?.length == 0"
          >
          {{ 'MSG_NO_DATA' | translate }}
        </mat-option>

        <ng-container>
          <mat-option [id]="'id_group_data_' + (i+1)" *ngFor="let data of groups; let i = index" [value]="data" [disabled]="data.disabled">
            <div (click)="optionClicked($event, data, groups, 'selectedGroups', 'group', groupInput)" [class.disable]="data.disabled">
              <mat-checkbox [id]="'id_group_data_checkbox' + (i+1)" [checked]="data.selected" (change)="toggleSelection(data, groups, 'selectedGroups', 'group', groupInput)" (click)="$event.stopPropagation()" [disabled]="data.disabled">
                {{ data.description }}
              </mat-checkbox>
            </div>
          </mat-option>
        </ng-container>
      
        <mat-option *ngIf="loading.group" disabled>
          <mat-spinner color="primary" class="spinner-margin-auto" mode="indeterminate" [diameter]="45"></mat-spinner>
        </mat-option>
      </mat-autocomplete>

        <mat-error *ngIf="formGroup.get('group').hasError('required')">
          {{ 'MSG_FIELD_REQUIRED' | translate }}
        </mat-error>

        <mat-error *ngIf="formGroup.get('group').hasError('notExisting')">
          {{ 'MSG_DOESNT_EXIST' | translate: {type: 'LABEL_GROUP' | translate} }}
        </mat-error>
      </mat-form-field>
    </form>
  </div>
  
</div>